import * as React from 'react';
import { observer } from 'mobx-react';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import { toggleAccessibilityOption } from '../data/actions/internalActions';
import getSelectedAccessibilityOption from '../selectors/getSelectedAccessibilityOption';
import strings from 'owa-strings/owa-options-strings';

/**
 * Component which renders the Accessibility Option
 */
export default observer(function AccessibilityFull() {
    return (
        <>
            <OptionDescription>{strings.option_accessibility_description}</OptionDescription>
            <OptionsCheckbox
                checked={getSelectedAccessibilityOption()}
                label={strings.option_accessibility_checkBoxLabel}
                onChange={onAccessibilityCheckBoxClicked}
            />
        </>
    );
});

const onAccessibilityCheckBoxClicked = (ev?: React.FormEvent<HTMLElement>, checked?: boolean) =>
    toggleAccessibilityOption(checked);
